var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactUsIcon = function SvgContactUsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 156,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#contactUsIcon_svg__a)",
    d: "M45 40.076V156H30.532V24.031C30.533 11.871 16.87 2 0 2h8.289C37.445 2 45 19.045 45 40.076"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#contactUsIcon_svg__b)",
    d: "M0 0h202v133H0z",
    opacity: 0.85,
    style: {
      mixBlendMode: "plus-lighter"
    },
    transform: "matrix(-1 0 0 1 247 0)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "contactUsIcon_svg__a",
    x1: 9,
    x2: -28.386,
    y1: 208.5,
    y2: -31.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711211"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "contactUsIcon_svg__b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(.00032 .00049)"
  })))));
};
export default SvgContactUsIcon;